import React from 'react';
import { Heading, Copy } from 'components/components/atoms';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import styled from 'styled-components';
import breakpoints from 'utils/breakpoints';

const HeadingContainer = styled.div`
  @media ${breakpoints.lg} {
    max-width: 35rem;
  }
`;

const CopyContainer = styled.div`
  @media ${breakpoints.lg} {
    max-width: 45rem;
  }
`;

const GetInTouch = ({ fields }) => {
  const title = getFieldValue(fields, 'title');
  const copy = getFieldValue(fields, 'copy');
  if (!(title || copy)) return '';
  return (
    <div className='flex flex-col items-center w-full md:mb-12'>
      {title && (
        <HeadingContainer>
          <Heading as='h2' className='lg:my-1'>
            {title}
          </Heading>
        </HeadingContainer>
      )}
      {copy && (
        <CopyContainer>
          <Copy className='leading-relaxed'>{copy}</Copy>
        </CopyContainer>
      )}
    </div>
  );
};

export default GetInTouch;
